import axios from '../../axiosConfig'
import pyChar from 'js-pinyin'
import '@/apolloConfig.js'
import gql from "@/graphql/apollo"
let state = {
    loading:true,
    recommends:[],
    recommendsGroup:[],
    manageAppList:[],
    manageGuides:[],
    manageTokenList:[],
    tagApps:[],
    tagGuides:[],
    appQuery: {
		seq:'',
		tag:'',
		department:''
	},
    positionsMes:[]
}

let getters = {
    Loading:()=>state.loading,
    getAppList:()=>state.manageAppList,
    getTagApps:()=>state.tagApps,
    getTagGuides:()=>state.tagGuides,
    getTokenList:()=>state.manageTokenList,
    getGuides:()=>state.manageGuides,
    getState:()=>state,
    getPositionsMes:()=>state.positionsMes,
}

let actions = {
    getRecommends({ state,dispatch }) {
        axios({
            method: "post",
            url: window.commonApi.TASKCENTER_URL+"/manage/apps/recommended",
        }).then(response => {
            let recommends = [];
            if(response.status == 200) {
                recommends = response.data.data;
            }
            let appIdArr = [];
            for(let i = 0; i < recommends.length; i++) {
                appIdArr.push(recommends[i].id);
            }
            state.recommends = recommends;
            if(appIdArr.length > 0) {
                dispatch('getGlById',appIdArr)
            }
        }).catch(error => {
            console.log(error); //请求失败返回的数据
        });
    },
    getGlById: function({ commit,state },appIdArr) {
        apolloProvider.clients.manage.query({
            query: gql.guide,
            variables: {
                appId: appIdArr
            }
        })
        .then(response => {
            let edges = response.data.guide.edges;
            let recommends = state.recommends;
            for(let i = 0; i < recommends.length; i++) {
                commit('getRecommendEdges',{recommend:recommends[i], edges:edges})
            }
            let recommendsGroup = [];
            let groupCount = Math.ceil(recommends.length / 3);
            for(let i = 0; i < groupCount; i++) {
                recommendsGroup.push(recommends.splice(0, 3));
            }
            console.log(recommendsGroup);
            state.recommendsGroup = recommendsGroup;
        })
        .catch(error => {})
    },
    //首页和全部事项的搜索，tag
	updateQuery({commit,state},{seq,tag,dep}){
		state.appQuery.seq = seq || state.appQuery.seq ;
		state.appQuery.tag = tag || state.appQuery.tag ;
		state.appQuery.department = dep || state.appQuery.department ;
        if(seq === 'all'){
            state.appQuery.seq = '';
        }
		if(tag === 'all'){
			state.appQuery.tag = '';
		}
		if(dep === 'all'){
			state.appQuery.department = '';
		}

		commit('updateAppAll');
	},
    /*
    * filterApps 外部方法
    * */
    getSearchResult({commit,dispatch,state},{seq,filterApps}){
        let keyword = seq || '';
        // state.appQuery.seq = keyword;
        commit('loadingSet',true);
        axios.post( window.commonApi.TASKCENTER_URL+"/manage/searchGuide?keyword=" + keyword).then(response => {
            if(response.data.code === 200){
                let res = response.data.t;
                let apps = res.appList?res.appList.map((item) => {
                    let obj = item;
                    obj.hit.shouzimu = pyChar.getFullChars(item.hit.name).toUpperCase().slice(0, 1);

                    // tag 的第二位配字母，强制分类到该字母那一类
                    let tagsLi = item.hit.tags.split(',');
                    if (tagsLi.length > 2 && tagsLi[1].length == 1){
                        obj.hit.shouzimu = tagsLi[1].toUpperCase();
                    }
                    return obj;
                }):[];
                if (filterApps){
                    apps = filterApps(apps);
                }
                state.manageAppList = apps ;
                state.manageGuides = res.guideList&&res.guideList.length?res.guideList:[];
                state.manageTokenList = res.tokenList || [keyword];
                commit('updateAppAll',apps);
                dispatch('getStatus',apps);
                commit('loadingSet',false);
                }
            }).catch(error => {
                console.log(error);
                commit('loadingSet',false);
            });
    },
    	//获取次数
	getStatus({state,commit,dispatch}, items) {
		axios.get(`${window.commonApi.INFOPLUS_URL}/stats/apps`)
			.then((res) => {
				if (res.data.errno == 0) {
					let stats = res.data.entities;
					let appList = items.map(function(item){
					   let id1 = item.hit.id;
					   let item2 = stats.filter(function(item){
						   return item.id === id1
					   })
                       item.hit.processCounters = item2[0]? (item2[0].processCounters.completed + item2[0].processCounters.killed + item2[0].processCounters.running + item2[0].processCounters.suspended + item2[0].processCounters.unknown) : 0;
					   return item
                   });
                   commit('updateAppAll',appList);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	},
    getPositionsMes({ commit,state }, id) {
        axios.get(`${window.commonApi.PATH}/api/user/positions?id=${id}`)
            .then((res) => {
                if (res.data.errno == 0) {
                    state.positionsMes = res.data.entities;
                }
            }).catch(function (error) {
                console.log(error)
        })
    }
}

let mutations = {
    getRecommendEdges(state,{recommend, edges}) {
        recommend.edges = [];
        let isOk = false;
        for(let j = 0; j < edges.length; j++) {
            let guideStepList = edges[j].node.guideStepList;
            for(let k = 0; k < guideStepList.length; k++) {
                let guideStepAppList = guideStepList[k].guideStepAppList;
                for(let d = 0; d < guideStepAppList.length; d++) {
                    if(guideStepAppList[d].appCode == recommend.code) {
                        recommend.edges.push(edges[j].node);
                        isOk = true;
                        break;
                    }
                }
                if(isOk) {
                    break;
                }
            }
        }
    },

    loadingSet(state,bool){
        state.loading =  bool;
    },

    updateAppAll(state,apps){
        if(apps){
            state.manageAppList = apps;
        }
		let all_apps = state.manageAppList;
        let all_Guides = state.manageGuides;
        if (state.appQuery.seq){
            all_apps = all_apps.filter((item)=>{
                return item.hit.name && item.hit.name.indexOf(state.appQuery.seq)>-1;
            });
            if(state.appQuery.tag){
                all_apps = all_apps.filter((item)=>{
                    return item.hit.tags && item.hit.tags.indexOf(state.appQuery.tag)>-1;
                });

                all_Guides = all_Guides.filter((item)=>{
                    let isOk=false;
                    let guideStepList = item.hit.guide_step;
                    for(let k = 0; k < guideStepList.length; k++) {
                        let guideStepAppList = guideStepList[k].guide_step_app;
                        for(let d = 0; d < guideStepAppList.length; d++) {
                            if(guideStepAppList[d].appTag&&guideStepAppList[d].appTag.indexOf(state.appQuery.tag)>-1) {
                                isOk = true;
                            }
                        }
                    }
                    return isOk;
                })
            }
            if(state.appQuery.department){
                all_apps = all_apps.filter((item)=>{
                    return item.hit.department && item.hit.department.indexOf(state.appQuery.department)>-1;
                });
            }
        }else {
            if(state.appQuery.tag){
                all_apps = all_apps.filter((item)=>{
                    return item.hit.tags && item.hit.tags.indexOf(state.appQuery.tag)>-1;
                });

                all_Guides = all_Guides.filter((item)=>{
                    let isOk=false;
                    let guideStepList = item.hit.guide_step;
                    for(let k = 0; k < guideStepList.length; k++) {
                        let guideStepAppList = guideStepList[k].guide_step_app;
                        for(let d = 0; d < guideStepAppList.length; d++) {
                            if(guideStepAppList[d].appTag&&guideStepAppList[d].appTag.indexOf(state.appQuery.tag)>-1) {
                                isOk = true;
                            }
                        }
                    }
                    return isOk;
                })
            }
            if(state.appQuery.department){
                all_apps = all_apps.filter((item)=>{
                    return item.hit.department && item.hit.department.indexOf(state.appQuery.department)>-1;
                });
            }
        }

		state.tagApps = all_apps;
        state.tagGuides = all_Guides;
	}
}

export default {
    namespaced: true,
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/manageApp.js